export enum InputType {
    None = -1,
    InputForm = 0,
    Tenkey = 1,
}